'use strict';

angular.module('app.error')
    .service('ModalError', ['Modal', 'ErrorMessages', 'gettext', function(Modal, ErrorMessages, gettext) {
        return {
            open: function(error, title) {
                return Modal.open({
                    template: 'html/error/modal.html',
                    data: {
                        errorTitle: title || gettext('Se ha producido un error'),
                        errorText: ErrorMessages.get(error),
                    },
                }).closePromise;
            },
        };
    }]);
